module.exports = __webpack_public_path__ + "static/img/newsBg.91f0d653.png";